import React, { Dispatch, SetStateAction, useState } from "react";
import { Box, Button, Grid, TextField, Stack } from "@mui/material";
import SaveAsIcon from "@mui/icons-material/SaveAs";
import { accessProfile } from "../../Requests";
import useGlobalContext from "../../Hooks/useGlobalContext";
import { useSnackbar } from "notistack";

interface IEditProfileDescriptionProps {
  idProfile: number;
  profileName: string;
  setProfileName: Dispatch<SetStateAction<string>>;
}

const EditProfileDescription: React.FC<IEditProfileDescriptionProps> = ({
  idProfile,
  profileName,
  setProfileName,
}) => {
  const { setLoading } = useGlobalContext();
  const { enqueueSnackbar } = useSnackbar();

  const [descricaoPerfil, setDescricaoPerfil] = useState<string>(profileName);
  const [message, setMessage] = useState<string>("");
  const [error, setError] = useState<boolean>(false);

  const handleChangeDescricaoPerfil = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDescricaoPerfil(event.target.value);
    if (error) {
      setError(false);
      setMessage('');
    }
  };

  const handleSaveDescription = async () => {
    setLoading?.(true);
    setError(false);
    setMessage("");

    const result = await accessProfile.put(`${idProfile}`, {
      id: idProfile,
      description: descricaoPerfil,
    });

    if (result?.errors || !result?.description) {
      setError(true);
      setMessage(result?.message || "Erro ao atualizar descrição.");
      enqueueSnackbar(result?.message || "Erro ao atualizar descrição.", { variant: "error" });
    } else {
      enqueueSnackbar("Descrição alterada com sucesso!", { variant: "success" });
      setDescricaoPerfil(result.description);
      setProfileName(result.description);
    }

    setLoading?.(false);
  };

  return (
    <Grid item xs={12}>
      <Box component="form" noValidate>
        <Stack spacing={3}>
          <TextField
            id="accessProfileDescription"
            label="Descrição do perfil"
            variant="filled"
            value={descricaoPerfil}
            onChange={handleChangeDescricaoPerfil}
            error={error}
            helperText={message}
            fullWidth
            autoComplete="off"
            autoFocus
            aria-label="Campo de descrição do perfil de acesso"
          />

          <Box display="flex" justifyContent="flex-end">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSaveDescription}
              startIcon={<SaveAsIcon />}
              aria-label="Salvar nova descrição do perfil"
            >
              Salvar descrição
            </Button>
          </Box>
        </Stack>
      </Box>
    </Grid>
  );
};

export default EditProfileDescription;
